import { Col, Form, Row } from "react-bootstrap";
import _ from "lodash";
import clsx from "clsx";
import Constants from "../../../../constants";
import Table from "react-bootstrap/Table";
import { Fragment, useEffect } from "react";

function ManualTransferTable({
  config,
  onClickAddNew,
  payment,
  register,
  formValues,
  setValue,
  removeDeposit,
  onChangeAmount,
  errors,
  watch,
  currency_code,
  currency_symbol,
}) {
  const bankConfig = _.get(config, ["banks"], []);
  const bankConfigs = _.filter(bankConfig, (item) => {
    return currency_code === _.get(item, ["currency_code", "value"]);
  });
  const companyBankConfig = _.get(config, ["company_banks"], []);
  const companyBankConfigs = _.filter(companyBankConfig, (item) => {
    return currency_code === _.get(item, ["currency_code", "value"]);
  });

  const onHandleCompanyBankChange = (e, index) => {
    const depositBank = formValues(`items.${index}.deposit_company_bank_id`);

    const targetBank = _.find(
      companyBankConfigs,
      _.matchesProperty("id", Number(depositBank)),
    );
    if (_.isEmpty(targetBank)) {
      setValue(`items.${index}.deposit_company_bank_account`, "");
      return;
    }
    setValue(
      `items.${index}.deposit_company_bank_account`,
      targetBank.bank_account,
    );
  };

  const onHandleDraweeBankChange = (e, index) => {
    const depositBank = formValues(`items[${index}][drawee_bank_id]`);
    const targetBank = _.find(
      bankConfigs,
      _.matchesProperty("id", Number(depositBank)),
    );

    if (_.isEmpty(targetBank)) {
      setValue(`items[${index}][drawee_bank_name]`, "");
      return;
    }
    setValue(`items[${index}][drawee_bank_name]`, targetBank.name);
  };

  const totalAmount = () => {
    const items = formValues("items");
    return _.sumBy(items, (item) => {
      return Number(_.get(item, ["amount"], 0));
    });
  };

  const onChangeType = (e, index) => {
    const currentType = e.target.value;
    switch (currentType) {
      case Constants.DIRECT_TRANSFER:
        setValue(`items[${index}][cheque_no]`, "");
        break;
      case Constants.CHEQUE:
        break;
      case Constants.CASH:
        setValue(`items[${index}][cheque_no]`, "");
        setValue(`items[${index}][drawee_bank_id]`, "");
        setValue(`items[${index}][drawee_bank_name]`, "");
        setValue(`items[${index}][drawee_bank_account]`, "");
        break;
    }
  };

  return (
    <>
      <div>
        <div className={"responsive-table-border"}>
          <Table responsive="xxl" className="deposit-table-table">
            <thead>
              <tr>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}>Payment</th>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}>Amount</th>
                <th style={{ minWidth: "100px", maxWidth: "10%" }}>
                  Bank in date
                </th>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}>
                  Drawee Bank (client)
                </th>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}>Cheque</th>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}>
                  Deposit Bank (TA)
                </th>
                <th style={{ minWidth: "120px", maxWidth: "15%" }}></th>
              </tr>
            </thead>
            <tbody>
              {payment &&
                _.map(Array(payment), (item, index) => {
                  const type = watch(`items[${index}][type]`);

                  return (
                    <Fragment>
                      <tr>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Type of payment</Form.Label>
                            <Form.Select
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              isInvalid={
                                errors?.items?.[index]?.type?.message && true
                              }
                              className="formControl"
                              {...register(`items[${index}][type]`, {
                                required: "Please select type of payment",
                                onChange: (e) => onChangeType(e, index),
                              })}
                            >
                              <option value="">
                                Please Select Payment Type
                              </option>
                              <option value={Constants.DIRECT_TRANSFER}>
                                Direct Transfer
                              </option>
                              <option value={Constants.CHEQUE}>Cheque</option>
                              <option value={Constants.CASH}>Cash</option>
                            </Form.Select>
                            {errors?.items?.[index]?.type?.message && (
                              <Form.Control.Feedback type="invalid">
                                {errors?.items?.[index]?.type?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Amount ({currency_symbol})</Form.Label>
                            <Form.Control
                              isInvalid={
                                errors?.items?.[index]?.amount?.message && true
                              }
                              className="formControl"
                              disabled={_.isEmpty(type)}
                              {...register(`items[${index}][amount]`, {
                                onChange: onChangeAmount,
                                required: "Please input amount",
                              })}
                            />
                            {errors?.items?.[index]?.amount?.message && (
                              <Form.Control.Feedback type="invalid">
                                {errors?.items?.[index]?.amount?.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "10%", maxWidth: "10%" }}>
                          <Form.Group>
                            <Form.Label>Bank in Date</Form.Label>
                            <Form.Control
                              className="formControl"
                              isInvalid={
                                errors?.items?.[index]?.bank_transaction_date &&
                                true
                              }
                              type="date"
                              disabled={_.isEmpty(type)}
                              {...register(
                                `items[${index}][bank_transaction_date]`,
                                {
                                  required: "Please input bank in date",
                                },
                              )}
                            />
                            {errors?.items?.[index]?.bank_transaction_date && (
                              <Form.Control.Feedback type="invalid">
                                {
                                  errors?.items[index].bank_transaction_date
                                    .message
                                }
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Drawee Bank</Form.Label>
                            <Form.Select
                              className="formControl"
                              disabled={
                                _.isEqual(type, Constants.CASH) ||
                                _.isEmpty(type)
                              }
                              isInvalid={
                                errors?.items?.[index]?.drawee_bank_id && true
                              }
                              {...register(`items[${index}][drawee_bank_id]`, {
                                onChange: (e) =>
                                  onHandleDraweeBankChange(e, index),
                                required:
                                  _.isEqual(type, Constants.DIRECT_TRANSFER) ||
                                  _.isEqual(type, Constants.CHEQUE)
                                    ? "Please select drawee bank"
                                    : false,
                              })}
                            >
                              <option value="">Please Select Bank</option>
                              {_.map(bankConfigs, (bank, index) => (
                                <option key={index} value={bank.id}>
                                  {bank.name}
                                </option>
                              ))}
                            </Form.Select>
                            {errors?.items?.[index]?.drawee_bank_id
                              ?.message && (
                              <Form.Control.Feedback type="invalid">
                                {
                                  errors?.items?.[index]?.drawee_bank_id
                                    ?.message
                                }
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Cheque No</Form.Label>
                            <Form.Control
                              className="formControl"
                              disabled={
                                _.isEmpty(type) ||
                                !_.isEqual(type, Constants.CHEQUE)
                              }
                              {...register(`items[${index}][cheque_no]`, {
                                required: _.isEqual(type, Constants.CHEQUE)
                                  ? "Please input cheque no"
                                  : false,
                              })}
                            />
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Deposit Bank</Form.Label>
                            <Form.Select
                              className="formControl"
                              disabled={_.isEmpty(type)}
                              isInvalid={
                                errors?.items?.[index]
                                  ?.deposit_company_bank_id && true
                              }
                              {...register(
                                `items[${index}][deposit_company_bank_id]`,
                                {
                                  required: "Please select deposit bank",
                                  onChange: (e) =>
                                    onHandleCompanyBankChange(e, index),
                                },
                              )}
                            >
                              <option value="">Please Select Bank</option>
                              {_.map(companyBankConfigs, (bank, index) => (
                                <option key={index} value={bank.id}>
                                  {bank.display_name}
                                </option>
                              ))}
                            </Form.Select>
                            {errors?.items?.[index]?.deposit_company_bank_id
                              ?.message && (
                              <Form.Control.Feedback type="invalid">
                                {
                                  errors?.items?.[index]
                                    ?.deposit_company_bank_id?.message
                                }
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td style={{ minWidth: "15%", maxWidth: "15%" }}>
                          <Form.Group>
                            <Form.Label>Deposit Bank Account</Form.Label>
                            <Form.Control
                              className="formControl"
                              readOnly
                              {...register(
                                `items[${index}][deposit_company_bank_account]`,
                                {
                                  readOnly: true,
                                },
                              )}
                            />
                          </Form.Group>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <Form.Group>
                            <Form.Label>File Upload</Form.Label>
                            <Form.Control
                              type="file"
                              disabled={_.isEmpty(type)}
                              isInvalid={
                                errors?.items?.[index]?.document && true
                              }
                              className="formControl file-input"
                              {...register(`items[${index}][document]`, {
                                required: "Please upload file attachment",
                              })}
                            />
                            {errors?.items?.[index]?.document && (
                              <Form.Control.Feedback type="invalid">
                                {errors?.items[index].document.message}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>

                        </td>
                        <td>
                          {index > 0 ? (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                removeDeposit(e, index);
                              }}
                              className={clsx("btn delete-button ")}
                            >
                              Remove
                            </button>
                          ) : (
                            false
                          )}
                          <Form.Control
                            className="formControl"
                            hidden
                            {...register(`items[${index}][drawee_bank_name]`)}
                          />
                        </td>
                      </tr>
                    </Fragment>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={2} className="text-start">
                  <Form.Group>
                    <Form.Label>Total Amount ({currency_symbol})</Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      isInvalid={errors?.amount && true}
                      {...register("amount", { readOnly: true })}
                    />
                    {errors?.amount && (
                      <Form.Control.Feedback type="invalid">
                        {errors?.amount.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </th>
                <th colSpan={2}>
                  <Form.Group>
                    <Form.Label>Client Remarks</Form.Label>
                    <Form.Control type="text" {...register("client_remarks")} />
                    <Form.Control
                      hidden
                      type="text"
                      {...register("client_code", { hidden: true })}
                    />
                    <Form.Control
                      hidden
                      type="text"
                      {...register("currency_code", { hidden: true })}
                    />
                  </Form.Group>
                </th>
              </tr>
            </tfoot>
          </Table>
        </div>
        {/*{payment &&*/}
        {/*  _.map(Array(payment), (item, index) => {*/}
        {/*    const type = watch(`items[${index}][type]`);*/}

        {/*    return (*/}
        {/*      <div key={index}>*/}
        {/*        <div className="d-flex deposit-form-title position-relative">*/}
        {/*          <p className="payment-detail-title text-bold-600 mb-0">Deposit Details ({index + 1})</p>*/}
        {/*          {index > 0 ? (*/}
        {/*            <button*/}
        {/*              onClick={(e) => {*/}
        {/*                e.preventDefault();*/}
        {/*                removeDeposit(e, index);*/}
        {/*              }}*/}
        {/*              className={clsx("btn delete-button ")}*/}
        {/*            >*/}
        {/*              Delete*/}
        {/*            </button>*/}
        {/*          ) : (*/}
        {/*            false*/}
        {/*          )}*/}
        {/*        </div>*/}
        {/*        <div className={clsx("p-3 deposit-form-container")}>*/}
        {/*          <Row className={clsx("deposit-form-table gy-2")}>*/}
        {/*            <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*              <Form.Group>*/}
        {/*                <Form.Label>Type of payment</Form.Label>*/}
        {/*                <Form.Select*/}
        {/*                  style={{*/}
        {/*                    whiteSpace: "nowrap",*/}
        {/*                    overflow: "hidden",*/}
        {/*                    textOverflow: "ellipsis",*/}
        {/*                  }}*/}
        {/*                  isInvalid={errors?.items?.[index]?.type?.message && true}*/}
        {/*                  className="formControl"*/}
        {/*                  {...register(`items[${index}][type]`, {*/}
        {/*                    required: "Please select type of payment",*/}
        {/*                  })}*/}
        {/*                >*/}
        {/*                  <option value="">Please Select Payment Type</option>*/}
        {/*                  <option value={Constants.DIRECT_TRANSFER}>Direct Transfer</option>*/}
        {/*                  <option value={Constants.CHEQUE}>Cheque</option>*/}
        {/*                  <option value={Constants.CASH}>Cash</option>*/}
        {/*                </Form.Select>*/}
        {/*                {errors?.items?.[index]?.type?.message && (*/}
        {/*                  <Form.Control.Feedback type="invalid">*/}
        {/*                    {errors?.items?.[index]?.type?.message}*/}
        {/*                  </Form.Control.Feedback>*/}
        {/*                )}*/}
        {/*              </Form.Group>*/}
        {/*            </Col>*/}
        {/*            <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*              <Form.Group>*/}
        {/*                <Form.Label>Amount (RM)</Form.Label>*/}
        {/*                <Form.Control*/}
        {/*                  isInvalid={errors?.items?.[index]?.amount?.message && true}*/}
        {/*                  className="formControl"*/}
        {/*                  {...register(`items[${index}][amount]`, {*/}
        {/*                    onChange: onChangeAmount,*/}
        {/*                    required: "Please input amount",*/}
        {/*                  })}*/}
        {/*                />*/}
        {/*                {errors?.items?.[index]?.amount?.message && (*/}
        {/*                  <Form.Control.Feedback type="invalid">*/}
        {/*                    {errors?.items?.[index]?.amount?.message}*/}
        {/*                  </Form.Control.Feedback>*/}
        {/*                )}*/}
        {/*              </Form.Group>*/}
        {/*            </Col>*/}
        {/*          </Row>*/}
        {/*          {!_.isEmpty(type) ? (*/}
        {/*            <>*/}
        {/*              <div className="d-flex mt-3 mb-2">*/}
        {/*                <p className="payment-detail-title text-bold-600 mb-0">Banks Details</p>*/}
        {/*              </div>*/}
        {/*              <Row className={clsx("deposit-form-table gy-3")}>*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Label>Bank Reference Number</Form.Label>*/}
        {/*                    <Form.Control*/}
        {/*                      className="formControl"*/}
        {/*                      isInvalid={errors?.items?.[index]?.bank_reference_number && true}*/}
        {/*                      {...register(`items[${index}][bank_reference_number]`, {*/}
        {/*                        required: "Please input bank reference number",*/}
        {/*                      })}*/}
        {/*                    />*/}
        {/*                    {errors?.items?.[index]?.bank_reference_number && (*/}
        {/*                      <Form.Control.Feedback type="invalid">*/}
        {/*                        {errors?.items[index].bank_reference_number.message}*/}
        {/*                      </Form.Control.Feedback>*/}
        {/*                    )}*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Label>Bank in Date</Form.Label>*/}
        {/*                    <Form.Control*/}
        {/*                      className="formControl"*/}
        {/*                      isInvalid={errors?.items?.[index]?.bank_transaction_date && true}*/}
        {/*                      type="date"*/}
        {/*                      {...register(`items[${index}][bank_transaction_date]`, {*/}
        {/*                        required: "Please input bank in date",*/}
        {/*                      })}*/}
        {/*                    />*/}
        {/*                    {errors?.items?.[index]?.bank_transaction_date && (*/}
        {/*                      <Form.Control.Feedback type="invalid">*/}
        {/*                        {errors?.items[index].bank_transaction_date.message}*/}
        {/*                      </Form.Control.Feedback>*/}
        {/*                    )}*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Label>Bank in Time</Form.Label>*/}
        {/*                    <Form.Control*/}
        {/*                      type="time"*/}
        {/*                      className="formControl"*/}
        {/*                      isInvalid={errors?.items?.[index]?.bank_transaction_time && true}*/}
        {/*                      {...register(`items[${index}][bank_transaction_time]`, {*/}
        {/*                        required: "Please input bank in time",*/}
        {/*                      })}*/}
        {/*                    />*/}
        {/*                    {errors?.items?.[index]?.bank_transaction_time && (*/}
        {/*                      <Form.Control.Feedback type="invalid">*/}
        {/*                        {errors?.items[index].bank_transaction_time.message}*/}
        {/*                      </Form.Control.Feedback>*/}
        {/*                    )}*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*                {_.isEqual(type, Constants.DIRECT_TRANSFER) || _.isEqual(type, Constants.CHEQUE) ? (*/}
        {/*                  <>*/}
        {/*                    <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                      <Form.Group>*/}
        {/*                        <Form.Label>Drawee Bank</Form.Label>*/}
        {/*                        <Form.Select*/}
        {/*                          className="formControl"*/}
        {/*                          isInvalid={errors?.items?.[index]?.drawee_bank_id && true}*/}
        {/*                          {...register(`items[${index}][drawee_bank_id]`, {*/}
        {/*                            onChange: (e) => onHandleDraweeBankChange(e, index),*/}
        {/*                            required: "Please select drawee bank",*/}
        {/*                          })}*/}
        {/*                        >*/}
        {/*                          <option value="">Please Select Bank</option>*/}
        {/*                          {_.map(bankConfigs, (bank, index) => (*/}
        {/*                            <option key={index} value={bank.id}>*/}
        {/*                              {bank.name}*/}
        {/*                            </option>*/}
        {/*                          ))}*/}
        {/*                        </Form.Select>*/}
        {/*                        {errors?.items?.[index]?.drawee_bank_id?.message && (*/}
        {/*                          <Form.Control.Feedback type="invalid">*/}
        {/*                            {errors?.items?.[index]?.drawee_bank_id?.message}*/}
        {/*                          </Form.Control.Feedback>*/}
        {/*                        )}*/}
        {/*                      </Form.Group>*/}
        {/*                    </Col>*/}

        {/*                    <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                      <Form.Group>*/}
        {/*                        <Form.Label>Drawee Bank Account</Form.Label>*/}
        {/*                        <Form.Control*/}
        {/*                          className="formControl"*/}
        {/*                          isInvalid={errors?.items?.[index]?.drawee_bank_account && true}*/}
        {/*                          {...register(`items[${index}][drawee_bank_account]`, {*/}
        {/*                            required: "Please input drawee bank account",*/}
        {/*                          })}*/}
        {/*                        />*/}
        {/*                        {errors?.items?.[index]?.drawee_bank_account?.message && (*/}
        {/*                          <Form.Control.Feedback type="invalid">*/}
        {/*                            {errors?.items?.[index]?.drawee_bank_account?.message}*/}
        {/*                          </Form.Control.Feedback>*/}
        {/*                        )}*/}
        {/*                      </Form.Group>*/}
        {/*                    </Col>*/}
        {/*                  </>*/}
        {/*                ) : (*/}
        {/*                  false*/}
        {/*                )}*/}
        {/*              </Row>*/}
        {/*            </>*/}
        {/*          ) : (*/}
        {/*            false*/}
        {/*          )}*/}
        {/*          {!_.isEmpty(type) ? (*/}
        {/*            <>*/}
        {/*              <div className="d-flex mt-3 mb-2">*/}
        {/*                <p className="payment-detail-title text-bold-600 mb-0">Other Details</p>*/}
        {/*              </div>*/}
        {/*              <Row className={clsx("deposit-form-table gy-2")}>*/}
        {/*                {_.isEqual(type, Constants.CHEQUE) ? (*/}
        {/*                  <>*/}
        {/*                    <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                      <Form.Group>*/}
        {/*                        <Form.Label>Cheque No</Form.Label>*/}
        {/*                        <Form.Control*/}
        {/*                          className="formControl"*/}
        {/*                          {...register(`items[${index}][cheque_no]`, {*/}
        {/*                            required: "Please input cheque no",*/}
        {/*                          })}*/}
        {/*                        />*/}
        {/*                      </Form.Group>*/}
        {/*                    </Col>*/}
        {/*                    <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                      <Form.Group>*/}
        {/*                        <Form.Label>Cheque Date</Form.Label>*/}
        {/*                        <Form.Control*/}
        {/*                          className="formControl"*/}
        {/*                          type="date"*/}
        {/*                          {...register(`items[${index}][cheque_date]`, {*/}
        {/*                            required: "Please input cheque date",*/}
        {/*                          })}*/}
        {/*                        />*/}
        {/*                      </Form.Group>*/}
        {/*                    </Col>*/}
        {/*                  </>*/}
        {/*                ) : (*/}
        {/*                  false*/}
        {/*                )}*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Label>Deposit Bank</Form.Label>*/}
        {/*                    <Form.Select*/}
        {/*                      className="formControl"*/}
        {/*                      isInvalid={errors?.items?.[index]?.deposit_company_bank_id && true}*/}
        {/*                      {...register(`items[${index}][deposit_company_bank_id]`, {*/}
        {/*                        required: "Please select deposit bank",*/}
        {/*                        onChange: (e) => onHandleCompanyBankChange(e, index),*/}
        {/*                      })}*/}
        {/*                    >*/}
        {/*                      <option value="">Please Select Bank</option>*/}
        {/*                      {_.map(companyBankConfigs, (bank, index) => (*/}
        {/*                        <option key={index} value={bank.id}>*/}
        {/*                          {bank.bank_name}*/}
        {/*                        </option>*/}
        {/*                      ))}*/}
        {/*                    </Form.Select>*/}
        {/*                    {errors?.items?.[index]?.deposit_company_bank_id?.message && (*/}
        {/*                      <Form.Control.Feedback type="invalid">*/}
        {/*                        {errors?.items?.[index]?.deposit_company_bank_id?.message}*/}
        {/*                      </Form.Control.Feedback>*/}
        {/*                    )}*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Label>Deposit Bank Account</Form.Label>*/}
        {/*                    <Form.Control*/}
        {/*                      className="formControl"*/}
        {/*                      readOnly*/}
        {/*                      {...register(`items[${index}][deposit_company_bank_account]`, {*/}
        {/*                        readOnly: true,*/}
        {/*                      })}*/}
        {/*                    />*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*              </Row>*/}
        {/*            </>*/}
        {/*          ) : (*/}
        {/*            false*/}
        {/*          )}*/}
        {/*          {!_.isEmpty(type) ? (*/}
        {/*            <>*/}
        {/*              <div className="d-flex mt-3 mb-1">*/}
        {/*                <p className="payment-detail-title text-bold-600 mb-1">File Attachment</p>*/}
        {/*              </div>*/}
        {/*              <Row>*/}
        {/*                <Col xxl={2} xl={3} lg={3} md={4} xs={6}>*/}
        {/*                  <Form.Group>*/}
        {/*                    <Form.Control*/}
        {/*                      type="file"*/}
        {/*                      isInvalid={errors?.items?.[index]?.document && true}*/}
        {/*                      className="formControl file-input"*/}
        {/*                      {...register(`items[${index}][document]`, {*/}
        {/*                        required: "Please upload file attachment",*/}
        {/*                      })}*/}
        {/*                    />*/}
        {/*                    {errors?.items?.[index]?.document && (*/}
        {/*                      <Form.Control.Feedback type="invalid">*/}
        {/*                        {errors?.items[index].document.message}*/}
        {/*                      </Form.Control.Feedback>*/}
        {/*                    )}*/}
        {/*                  </Form.Group>*/}
        {/*                </Col>*/}
        {/*              </Row>*/}
        {/*            </>*/}
        {/*          ) : (*/}
        {/*            false*/}
        {/*          )}*/}
        {/*        </div>*/}
        {/*        <Form.Control*/}
        {/*          className="formControl"*/}
        {/*          hidden*/}
        {/*          {...register(`items[${index}][drawee_bank_name]`)}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*<div className={clsx("d-flex mt-4 mb-4")}>*/}
        {/* */}
        {/*</div>*/}
        {/*<div className="d-flex deposit-form-title mt-4">*/}
        {/*  <p className="payment-detail-title text-bold-600 mb-0">Summary</p>*/}
        {/*</div>*/}
        {/*<div className={clsx("p-3 pt-0 deposit-form-container")}>*/}
        {/*  <Row>*/}
        {/*    <Col xxl={6} xl={6} lg={6} md={6} xs={12}>*/}
        {/*      <div className="d-flex align-items-center h-100 mt-2">*/}
        {/*        <div className="w-100">*/}
        {/*          <Form.Group>*/}
        {/*            <Form.Label>Total Amount</Form.Label>*/}
        {/*            <Form.Control*/}
        {/*              type="text"*/}
        {/*              readOnly*/}
        {/*              isInvalid={errors?.amount && true}*/}
        {/*              {...register("amount", { readOnly: true })}*/}
        {/*            />*/}
        {/*            {errors?.amount && (*/}
        {/*              <Form.Control.Feedback type="invalid">{errors?.amount.message}</Form.Control.Feedback>*/}
        {/*            )}*/}
        {/*          </Form.Group>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </Col>*/}
        {/*    <Col xxl={6} xl={6} lg={6} md={6} xs={12}>*/}
        {/*      <div className="d-flex align-items-center h-100 mt-2">*/}
        {/*        <div className="w-100">*/}
        {/*          <Form.Group>*/}
        {/*            <Form.Label>Client Remarks</Form.Label>*/}
        {/*            <Form.Control type="text" {...register("client_remarks")} />*/}
        {/*            <Form.Control hidden type="text" {...register("client_code", { hidden: true })} />*/}
        {/*            <Form.Control hidden type="text" {...register("currency_code", { hidden: true })} />*/}
        {/*          </Form.Group>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*</div>*/}
      </div>
    </>
  );
}

export default ManualTransferTable;
